import { GraphQLErrors } from '@apollo/client/errors';
import { isUndefined } from 'src/utils/typeguards/isUndefined';
import { isUnauthenticatedStatusInResponse } from './isUnauthenticatedStatusInResponse';

export const isUnauthenticatedError = (graphQLErrors: undefined | GraphQLErrors): boolean =>
    !isUndefined(graphQLErrors) && !!graphQLErrors.length && isUnauthenticatedStatusInResponse(graphQLErrors);
